import { FreeSpaceStatePresenter } from '@/presentation/presenters/freeSpace/freeSpaceStatePresenter'
import { FreeSpaceStateViewModel } from '@/presentation/viewmodels/freeSpace/freeSpaceStateViewModel'

export function useFreeSpaceStatePresenter(
  presenter: FreeSpaceStatePresenter = new FreeSpaceStatePresenter(new FreeSpaceStateViewModel())
) {
  return {
    sourceCode: presenter.sourceCode,
    testInput: presenter.testInput,
    userOutput: presenter.userOutput,
    isErrorShow: presenter.isErrorShow,
    errorMessage: presenter.errorMessage,
    setSourceCode: presenter.setSourceCode.bind(presenter),
    setTestInput: presenter.setTestInput.bind(presenter),
    setIsErrorShow: presenter.setIsErrorShow.bind(presenter),
    setErrorMessage: presenter.setErrorMessage.bind(presenter)
  }
}
